export default __webpack_public_path__ + "static/media/grunge-2667529_1920.7da45a09.jpg";